import React, { useState } from 'react';
import styled from 'styled-components';
import { DictionaryTab } from './DictionaryTabs';
import * as QuickAccessDictionaryUI from './QuickAccessDictionaryUI';
import { EntityTabType } from './DictionaryTabs/types';
import { IconWrapper, SvgIcon } from '../Icon';
import { Tab, TabList, TabPanel, Tabs } from '../Tabs';
import DictionaryView from './DictionaryView';
import useDictionarySettings from './useDictionarySettings';
import SearchInput from '../Form/SearchInput';

const StyledTabList = styled(TabList)`
  padding-right: 8px;
  padding-left: 8px;
`;

const entityTabs = [
  EntityTabType.Events,
  EntityTabType.Fields,
  EntityTabType.Measures,
  EntityTabType.Cohorts,
];

const entityTabLabels: Record<EntityTabType, string> = {
  [EntityTabType.Events]: 'Events',
  [EntityTabType.Fields]: 'Fields',
  [EntityTabType.Measures]: 'Measures',
  [EntityTabType.Cohorts]: 'Cohorts',
};

interface IProps {
  onClose: () => void;
}

const QuickAccessDictionary = ({ onClose }: IProps) => {
  const [searchTerm, setSearchTerm] = useState('');

  const {
    activeEntityType,
    onChangeEntityType,
    activeIndices,
    toggleActiveIndex,
  } = useDictionarySettings();

  const handleChangeTab = (tabIndex: number) => {
    onChangeEntityType(entityTabs[tabIndex]);
  };

  return (
    <QuickAccessDictionaryUI.Wrapper>
      <QuickAccessDictionaryUI.StaticPart>
        <QuickAccessDictionaryUI.Header>
          <QuickAccessDictionaryUI.Row>
            <QuickAccessDictionaryUI.Title>
              Dictionary
            </QuickAccessDictionaryUI.Title>
            <DictionaryView />
          </QuickAccessDictionaryUI.Row>
          <IconWrapper size={24} onClick={onClose}>
            <SvgIcon
              name="nav-expand"
              height={16}
              width={16}
              customFill="currentColor"
            />
          </IconWrapper>
        </QuickAccessDictionaryUI.Header>
        <SearchInput
          value={searchTerm}
          onChange={setSearchTerm}
          isFullWidth={true}
        />
      </QuickAccessDictionaryUI.StaticPart>

      <Tabs onTabChange={handleChangeTab}>
        <StyledTabList>
          {entityTabs.map((tabType, index) => (
            <Tab
              key={`${tabType}-label`}
              tabIndex={index}
              defaultActive={activeEntityType === tabType}
            >
              {entityTabLabels[tabType]}
            </Tab>
          ))}
        </StyledTabList>
        {entityTabs.map((tabType, index) => (
          <TabPanel key={tabType} tabIndex={index}>
            <QuickAccessDictionaryUI.TabContent>
              <DictionaryTab
                entityTabType={tabType}
                searchTerm={searchTerm}
                activeIndices={activeIndices}
                toggleActiveIndex={toggleActiveIndex}
              />
            </QuickAccessDictionaryUI.TabContent>
          </TabPanel>
        ))}
      </Tabs>
    </QuickAccessDictionaryUI.Wrapper>
  );
};

export default QuickAccessDictionary;
